import { useEffect, useState } from 'react';

const useCanScrollUp = () => {
  const [scrollingContainer, setScrollingContainer] =
    useState<HTMLElement | null>(null);

  const [canScrollUp, setCanScrollUp] = useState(false);

  useEffect(() => {
    if (!scrollingContainer) return undefined;

    const updateState = () => {
      setCanScrollUp(scrollingContainer.scrollTop > 0);
    };

    updateState();

    scrollingContainer.addEventListener('scroll', updateState, {
      passive: true,
    });
    return () => {
      scrollingContainer.removeEventListener('scroll', updateState);
    };
  }, [scrollingContainer]);

  return { canScrollUp, setScrollingContainer };
};

export default useCanScrollUp;
